import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {CefrlExamService} from '../../../services/cefrl-exam/cefrl-exam.service';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-cefrl-exam-state',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent
  ],
  templateUrl: './cefrl-exam-state.component.html',
  styleUrls: ['./cefrl-exam-state.component.scss']
})
export class CefrlExamStateComponent implements OnInit {

  loading = true;
  state: any;

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private route: ActivatedRoute,
    private cefrlExamSrv: CefrlExamService
  ) {
  }

  async ngOnInit() {
    this.translate.get(`Examen`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.state = await this.cefrlExamSrv.state(this.route.snapshot.params.idSection);
    if (!this.state) {
      await this.close();
      return;
    }
    this.loading = false;
  }

  async close() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'games']);
  }

  async start() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'cefrl-exam', this.route.snapshot.params.idSection, 'questions']);
  }

  async viewResult() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'cefrl-exam', this.route.snapshot.params.idSection, 'result']);
  }

  // Prochaine étape du parcours (exposée par l'API dans state.nextStep)
  get hasNextStep(): boolean {
    return !!this.state?.nextStep && this.state.nextStep.unlocked !== false;
  }

  async goToNextStep() {
    const lang = this.langSrcSrv.current.shortCode;
    const next = this.state?.nextStep;
    if (!next) {
      await this.router.navigate(['/', lang, 'games']);
      return;
    }
    if (next.type === 'exam') {
      await this.router.navigate(['/', lang, 'cefrl-exam', next.uniqid]);
      return;
    }
    await this.router.navigate(['/', lang, 'games', next.uniqid]);
  }

}
